module.exports = __webpack_public_path__ + "img/down-arrow.1f7c6359.svg";